import UserRole from "@domain/models/UserRole";
import { useEffect } from "react";
import NotificationModal from "@view/common/NotificationModal/NotificationModal";
import { useNotificationModal } from "@view/common/NotificationModal/useNotificationModal";
import LoginPageDecorationSection from "./LoginPageDecorationSection";
import styles from "./LoginPage.module.css";
import { useRouter } from "next/router";
import useAppState from "@view/common/AppState/useAppState";
import LoginManager from "@view/common/LoginManager";

const LoginPage = () => {

  const router = useRouter();
  const { sessionState } = useAppState();
  const { openNotificationModal, notificationModalProps } = useNotificationModal();

  const goToHome = () => {
    if (sessionState.roles.includes(UserRole.Staff)) {
      router.push("/admin");
    } else if (sessionState.roles.includes(UserRole.Student)) {
      router.push("/students");
    } else {
      openNotificationModal({
        variant: "error",
        title: "Error",
        description: "Lo sentimos no se pudo reconocer su tipo de usuario. Intenta iniciar sesión nuevamente.",
        actionLabel: "Aceptar"
      });
    }
  };

  useEffect(() => {
    if (sessionState.isLogin) {
      goToHome();
    }
  }, [sessionState.isLogin]);

  return (
    <div className={styles.root}>
      <LoginPageDecorationSection />
      <LoginManager />
      <NotificationModal {...notificationModalProps} />
    </div>
  );
}

export default LoginPage;
